$.widget("EASY.tabScrollButtons" , $.EASY.Widget, {
    // Name is there for developers comfort especially in error reporting
    name:"Left and right tab scrolling buttons",

    _customInit: function(){
        var self = this;

        var lis = self.element.find('ul').children('li');
        var tabsWidth = 0;
        self.element.each(function() {
            lis.each(function(index, li) {
                if ($(li).is(":visible")) {
                    tabsWidth += $(li).outerWidth();
                }
            });
            if ((tabsWidth < self.element.width() - 120) && (lis.first().is(":visible"))) {
                self.element.prev('div.tabs-buttons, td.tabs-button').hide();
            } else {
                self.element.prev('div.tabs-buttons, td.tabs-button').show();
            }
        });

        var leftButton = self.element.prev('div.tabs-buttons, td.tabs-button').find('.tab-left');
        var rightButton = self.element.prev('div.tabs-buttons, td.tabs-button').find('.tab-right');
        var scroll = self.element.scrollLeft();

        leftButton.click( function(){
            requestAnimationFrame(function(){
                self.element.scrollLeft(scroll - 120);
            });
        });

        rightButton.click( function(){
            requestAnimationFrame(function(){
                self.element.scrollLeft(scroll + 120);
            });
        });
    },

    _customDestroy: function(){

    }

});
